import React, {useContext} from "react";

const defaultValue = {
    title: '',
    component: (<div></div>),
    open: false,
    modal2: {
        open: false,
        component: null,
        title: ''
    }
}

export const ModalActions = {
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    CLOSE_ALL_MODALS: 'CLOSE_ALL_MODALS',
}

const ModalContext = React.createContext(defaultValue)

function modalReducer(state, action)
{
    switch (action.type)
    {
        case ModalActions.OPEN_MODAL: {
            if(state.open)
            {
                return {
                    ...state,
                    modal2: {
                        open: true,
                        component: action.component,
                        title: action.title,
                        onCloseFn: action.onCloseFn
                    }
                }
            }

            return {
                ...state,
                open: true,
                component: action.component,
                title: action.title,
                onCloseFn: action.onCloseFn
            }
        }
        case ModalActions.CLOSE_MODAL: {
            if(state.modal2.open)
            {
                if(state?.modal2?.onCloseFn)
                    state?.modal2?.onCloseFn()
                return {
                    ...state,
                    modal2: defaultValue.modal2
                }
            }

            if(state?.onCloseFn)
            {
                state?.onCloseFn()
                state.component = null
            }

            return defaultValue
        }
        // Sayfa değişiminde (NavigationBridge): iki katman da kapanır. onCloseFn çağrılmaz —
        // çoğu eski sayfanın grid'ini tazeler, o sayfa artık yok.
        case ModalActions.CLOSE_ALL_MODALS: {
            if(!state.open && !state.modal2.open)
                return state

            return defaultValue
        }
        default: {
            return defaultValue
        }
    }
}

function ModalProvider({children})
{
    const [modal, dispatch] = React.useReducer(modalReducer, defaultValue);

    const value = {modal, dispatch};

    return (
        <ModalContext.Provider value={value}>
            {children}
        </ModalContext.Provider>
    )
}

function useModal()
{
    const context = React.useContext(ModalContext);

    if(!context)
        throw new Error('Modal Provider Error')

    const {modal, dispatch} = context;

    const openModal = (title, component, onCloseFn) => {
        dispatch({
            type: ModalActions.OPEN_MODAL,
            component: component,
            title: title,
            onCloseFn
        })
    }

    const closeModal = () => {
        dispatch({
            type: ModalActions.CLOSE_MODAL,
        })
    }

    const closeAllModals = () => {
        dispatch({
            type: ModalActions.CLOSE_ALL_MODALS,
        })
    }

    return {
        modal: modal,
        openModal,
        closeModal,
        closeAllModals
    }
}

export {ModalProvider, useModal}
